import { Button, ButtonGroup } from "@progress/kendo-react-buttons";
import jwt_decode from "jwt-decode";
import MapContext from "../MapContext";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCookie } from "../../api/axios";
import Input from "./Input";
import { Error } from "@progress/kendo-react-labels";
import { SaveNewFeatureData, encodeDefaultValue } from "./editUtils";
import { setActiveSideBarTab, setActiveTool } from "../../redux/toolSelectSlice";
import { clearEdits } from "../../redux/editingSlice";
import { getMapLayerById } from "../utils/mapUtils";
import { makeArray } from "../../permissionUtils";
const NewFeatureAttributes = (prop) => {
    const mapConfig = useSelector((state) => state.configData.mapConfig);
    const dispatch = useDispatch();
    const { map } = useContext(MapContext);
    const currentEditFeature = useSelector(
        (state) => state.editingOptions.currentFeature
    );

    const parentInfo = prop.prop;
    const locValue = useRef();
    const token = getCookie("ast");
    let userGivenName = "Guest";
    let tokenRoles = ["GUEST"];
    if (token) {
        userGivenName = jwt_decode(token).preferred_username;
        tokenRoles = jwt_decode(token).realm_access.roles;
    }

    const [formValues, setFormValues] = useState([]);
    const [validationMessage, setValidationMessage] = useState();
    useEffect(() => {
        let fieldsList = makeArray(parentInfo.selectedLayer.Fields.Field);
        if (formValues.length === 0 && fieldsList.length > 0) {
            let val = [];
            fieldsList.map((el) => {
                if (el.Visible || el.Type === "GUID") {
                    val.push({
                        id: `input_${el.Name}`,
                        label: el.DisplayName ?? el.Name,
                        type: el.Type?.toLowerCase() ?? "string",
                        value:
                            encodeDefaultValue(
                                el.DefaultValue,
                                userGivenName,
                                parentInfo.addressIn,
                                parentInfo.shape
                            ) ?? "",
                        domains: el.Domains,
                        charLimit: el.CharLimit,
                    });
                }
            });
            setFormValues(() => {
                return val;
            });
        }
    }, [formValues]);

    const back = () => {
        parentInfo.returnToParent();
    };

    const handleChange = (e, index) => {
        const values = [...formValues];
        values[index].value = e.target.value;
        setFormValues(values);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let attArr = formValues.map((val) => {
            let value;
            // handle falsy values (0, "", undefined, null, false) change to null
            if (val.type === "date" && val.value == false) {
                value = null;
            } else if (val.type === "date" && typeof val.value === "number") {
                value = val.value;
            } else if (val.type === "date" && typeof val.value === "object") {
                value = val.value.valueOf();
            } else if (val.type === "date" && typeof val.value === "string") {
                let temp = new Date(val.value);
                if (temp.toString() !== "Invalid Date") {
                    value = temp.valueOf();
                }
            } else {
                value = val.value;
            }
            return {
                fieldName: val.id.replace("input_", ""),
                fieldValue: value,
            };
        });
        SaveNewFeatureData(
            parentInfo.selectedLayer,
            attArr,
            parentInfo.shape,
            saveCallback
        );
    };

    const saveCallback = (evt) => {
        if (evt.error) {
            setValidationMessage(evt.error);
        } else {
            let layer = getMapLayerById(map, evt.layer.Id);
            layer.getSource().refresh();
            let layerLabel = getMapLayerById(map, evt.layer.Id + "_label")?.getSource();
            if (layerLabel) {
                layerLabel.refresh();
            }
            setValidationMessage();
            dispatch(clearEdits());
            dispatch(setActiveTool(""));
            dispatch(setActiveSideBarTab(2));
        }
    };

    return (
        <>
            {" "}
            {mapConfig && (
                <>
                    <Button onClick={back} className="back-button">
                        &lt;
                    </Button>
                    <h3 className="title">
                        Create {parentInfo.selectedLayer.DisplayName}
                    </h3>
                    <h4>Attributes</h4>
                    <>{locValue.current}</>

                    <form onSubmit={handleSubmit}>
                        {formValues.map((obj, index) => (
                            <Input
                                key={index}
                                objValue={obj}
                                onChange={handleChange}
                                index={index}
                            />
                        ))}
                        {validationMessage && <Error>{validationMessage}</Error>}
                        <Button
                            title="Submit"
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success submit-button">
                            Save
                        </Button>
                    </form>
                </>
            )}
        </>
    );
};
export default NewFeatureAttributes;
